// src/utils/tokens.js

export const editorial = {
  headlineL: { fontFamily: "'EscrowComp', serif", fontWeight: "700", fontSize: "40px", lineHeight: "42px" },
  headlineM: { fontFamily: "'EscrowComp', serif", fontWeight: "700", fontSize: "32px", lineHeight: "36px" },
  headlineS: { fontFamily: "'EscrowCondensed', serif", fontWeight: "700", fontSize: "24px", lineHeight: "28px" },
  headlineMedia: { fontFamily: "'Retina', sans-serif", fontWeight: "500", fontSize: "16px", lineHeight: "22px" },
  paragraph: { fontFamily: "'Exchange', serif", fontWeight: "400", fontSize: "16px", lineHeight: "26px" },
  paragraphLink: { fontFamily: "'Exchange', serif", fontWeight: "400", fontSize: "16px", lineHeight: "26px", textDecoration: "underline"},
  summary: { fontFamily: "'Retina', sans-serif", fontWeight: "400", fontSize: "16px", lineHeight: "22px" },
  byline: { fontFamily: "'Retina', sans-serif", fontWeight: "500", fontSize: "14px", lineHeight: "20px" },
  supportingCaption: { fontFamily: "'Retina', sans-serif", fontWeight: "400", fontSize: "14px", lineHeight: "20px" },
  credit: { fontFamily: "'Retina', sans-serif", fontWeight: "400", fontSize: "12px", lineHeight: "20px", textTransform: "uppercase"},
};

export const utility = {
  strap: { fontFamily: "'Retina Narrow', sans-serif", fontWeight: "500", fontSize: "18px", lineHeight: "24px", textTransform: "uppercase", letterSpacing: "0.54px"},
  label: { fontFamily: "'Retina Narrow', sans-serif", fontWeight: "500", fontSize: "13px", lineHeight: "16px", letterSpacing: "0.8px"},
  button: { fontFamily: "'Retina', sans-serif", fontWeight: "500", fontSize: "14px", lineHeight: "20px" },
  buttonTertiary: { fontFamily: "'Retina', sans-serif", fontWeight: "500", fontSize: "14px", lineHeight: "20px", textDecoration: "underline"},
  buttonALT: { fontFamily: "'Retina', sans-serif", fontWeight: "500", fontSize: "16px", lineHeight: "auto" },
};
  
export const spacing = {
    "xxxs": 0,
    "xxs": 2,
    "xs": 4,
    "s": 8,
    "m": 16,
    "l": 24,
    "xl": 32,
    "xxl": 48,
    "xxxl": 64
  };

export const borderRadius = {
    "xxs": 2,
    "xs": 4,
    "s": 8,
    "m": 12,
    "l": 16,
    "xl": 24
};

export const iconSize = {
  regular: 24
}